import AlertCircle from '@/assets/icons/AlertCircle.svg';
import CheckCircle from '@/assets/icons/CheckCircle.svg';
import { PromoBadge } from '@/components/PromoBadge';
import { ButtonVariant } from '@/constants';
import type { Product } from '@/types';
import * as Styled from './CartNotification.styled';
import { Button } from '@/components/Button';
interface ToastMessage {
  body: string;
  heading: string;
}

interface CartNotificationProps {
  isError?: boolean;
  message: ToastMessage;
  product: Product;
  url?: string;
}

export const CartNotification = ({
  isError = false,
  message,
  product,
  url,
}: CartNotificationProps) => (
  <Styled.Container>
    <Styled.ToastHeading $isError={isError}>
      <div className="icon">{isError ? <AlertCircle /> : <CheckCircle />}</div>
      <div>
        {message.heading ? (
          // biome-ignore lint/security/noDangerouslySetInnerHtml: we trust the source of the HTML
          <div dangerouslySetInnerHTML={{ __html: message.heading }} />
        ) : null}
        {message.body ? (
          // biome-ignore lint/security/noDangerouslySetInnerHtml: we trust the source of the HTML
          <div dangerouslySetInnerHTML={{ __html: message.body }} />
        ) : null}
      </div>
    </Styled.ToastHeading>
    <Styled.ProductDetailsWrapper>
      <Styled.Thumbnail>
        <img
          alt={product.image?.altText ?? ''}
          src={product.image?.thumbnailSrc ?? product.image?.mainSrc ?? ''}
        />
        {product.promoBadge && product.promoBadge.src ? (
          <PromoBadge
            altText={product.promoBadge.altText}
            src={product.promoBadge.src}
          />
        ) : null}
      </Styled.Thumbnail>
      <Styled.ProductDetails>
        <Styled.ProductName>{product.name}</Styled.ProductName>
        {product.author ? (
          <Styled.Author>{product.author}</Styled.Author>
        ) : null}
        <Styled.Price>{product.price?.current}</Styled.Price>
      </Styled.ProductDetails>
    </Styled.ProductDetailsWrapper>
    {!isError ? (
     <Button
       href={url ?? '/checkout'}
       isLink={true}
       variant={[ButtonVariant.FullWidth, ButtonVariant.Primary]}
     >
      Go to checkout
     </Button>
     ) : null}
    <Styled.DismissButton
      slot="close"
      variant={[ButtonVariant.FullWidth, ButtonVariant.Secondary]}
    >
     Continue shopping
    </Styled.DismissButton>
  </Styled.Container>
);
